import api from "api/api";

export const createCountryHolidaysQuery = async (data) =>
  await api.post("/settings/country-holidays", data);

export const updateCountryHolidaysByIdQuery = async (id, data) =>
  await api.put(`/settings/country-holidays/${id}`, data);

export const getCountryHolidaysByIdQuery = async (id) =>
  await api.get(`/settings/country-holidays/${id}`);

export const getCountryHolidaysListQuery = async () =>
  await api.get("/settings/country-holidays");

export const deleteCountryHolidaysByIdQuery = async (id) =>
  await api.delete(`/settings/country-holidays/${id}`);
